import React from 'react';
import { isGroupLeague, canHaveGroupStages, NO_GROUP_STAGES_TEXT } from '../utilities/stagePriority';
import '../styles/leagueManagement.css';

// Выбор этапа стадии в лиге с группами: групповой этап или плей-офф.
// Номер стадии считает utilities/stagePriority — админ его не вводит.
// props: format, phase ('group' | 'playoff'), onChange(phase), disabled
export default function StagePhasePicker({ format, phase, onChange, disabled }) {
  if (!isGroupLeague(format)) return null;
  const groupAllowed = canHaveGroupStages(format);
  return (
    <div className="form-section-modal">
      <label className="form-label-modal form-label-required">Этап</label>
      <div className="segmented">
        <button
          type="button"
          className={`segmentedItem ${phase === 'group' ? 'segmentedItemActive' : ''}`}
          disabled={disabled || !groupAllowed}
          onClick={() => onChange('group')}
        >
          <strong>Групповой этап</strong>
          <span>результаты идут в таблицу групп</span>
        </button>
        <button
          type="button"
          className={`segmentedItem ${phase === 'playoff' ? 'segmentedItemActive' : ''}`}
          disabled={disabled}
          onClick={() => onChange('playoff')}
        >
          <strong>Плей-офф</strong>
          <span>сетка на вылет</span>
        </button>
      </div>
      {!groupAllowed && (
        <small style={{ color: '#c53030', fontSize: '13px', marginTop: '6px', display: 'block' }}>
          {NO_GROUP_STAGES_TEXT}
        </small>
      )}
    </div>
  );
}
